import { render, staticRenderFns } from "./Vipstu.vue?vue&type=template&id=663bd2cd&scoped=true"
import script from "./Vipstu.vue?vue&type=script&lang=js"
export * from "./Vipstu.vue?vue&type=script&lang=js"
import style0 from "./Vipstu.vue?vue&type=style&index=0&id=663bd2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bd2cd",
  null
  
)

export default component.exports